export default "/assets/markers/driver_off.png"